import { tmsAllowRoles } from 'data/facts/userRolesValidations';
import { FactsScreenToastMessages } from 'data/toastMessages/facts';
import { useStore } from 'hooks/useStore';
import { futureTmsDeactivatationRequestPayload } from 'Interfaces/FactsInterfaces/tmsInterfaces';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { factScreenServices } from 'services/factsScreenServices';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';

export const useMarketHistoryValues = () => {
  const {
    UserStore: { userModulesRoles },
    FactsStore: {
      marketStrategyHistoricalData,
      isMarketHistoryLoading,
      deleteParticularIndexFutureTms,
    },
  } = useStore();
  const [deletingIndexes, setDeletingIndexes] = useState<Set<number>>(new Set());
  const columnDetails = [
    {
      key: 'tms',
      label: 'TMS (%)',
    },
    {
      key: 'strategy',
      label: 'Strategy',
    },
    {
      key: 'startDate',
      label: 'Start Date',
    },
    {
      key: 'endDate',
      label: 'End Date',
    },
  ];

  const handleDeleteFutureTms = async (
    marketShareId: number,
    _startDate: string,
    _endDate: string
  ) => {
    try {
      const tempDeletingIndexes = [...deletingIndexes];
      const tmepIndexes = new Set<number>([...tempDeletingIndexes]);
      tmepIndexes.add(marketShareId);
      setDeletingIndexes(tmepIndexes);

      // payload for deactivating future tms
      const payload: futureTmsDeactivatationRequestPayload = {
        MarketShareID: marketShareId,
      };

      // deactivate particular future tms value
      await factScreenServices.deactivateFutureTms(payload);

      // remove that particular markte share id future instance from already stored historical/future market share values data
      deleteParticularIndexFutureTms(marketShareId);

      // show success toast
      toast.success(FactsScreenToastMessages.TMS_HISTORY_DELETE_MESSAGE);
    } catch (_err) {
      toast.success("Future TMS couldn't be deleted, please try again later");
    } finally {
      const tempDeletingIndexes = [...deletingIndexes];
      const tmepIndexes = new Set<number>([...tempDeletingIndexes]);
      // tmepIndexes.add(marketShareId);
      tmepIndexes.delete(marketShareId);
      setDeletingIndexes(tmepIndexes);
    }
  };

  const checkIfCurrentRowIsBeingDelete = (marketShareId: number) => {
    if (deletingIndexes.has(marketShareId)) return true;
    return false;
  };

  return {
    columnDetails,
    marketStrategyHistoricalData,
    isMarketHistoryLoading,
    handleDeleteFutureTms,
    checkIfCurrentRowIsBeingDelete,
    checkIfFunctionalityEnabled,
    userModulesRoles,
    tmsAllowRoles,
  };
};
